export const camelize = function (str) {
    let arr = str.split('-');
    let capital = arr.map((item, index) => index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item);
    // ^-- change here.
    let capitalString = capital.join("");
    return capitalString;
}

export const capitalize = function ([first, ...rest]) {
    return first.toUpperCase(first) + rest.join('');
}

export const dependenciesCheck = function () {
    var passed = true;

    for (var i = 0; i < arguments.length; i++) {
        var argBooleanValue = !!(typeof arguments[i] === 'string' || arguments[i] instanceof jQuery ? arguments[i].length : arguments[i]);
        passed = (passed && argBooleanValue);
    }

    return passed;
};

export const isTouchDevice = function () {
    return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
};

/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 *`{leading: false}`. To disable execution on the trailing edge, ditto.
 * @param func
 * @param wait
 * @param options
 * @returns {function(): *}
 */
export const throttle = function (func, wait, options) {
    var context, args, result
    var timeout = null
    var previous = 0
    if (!options) options = {}
    var later = function () {
        previous = options.leading === false ? 0 : Date.now()
        timeout = null
        result = func.apply(context, args)
        if (!timeout) context = args = null
    }
    return function () {
        var now = Date.now()
        if (!previous && options.leading === false) previous = now
        var remaining = wait - (now - previous)
        context = this
        args = arguments
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout)
                timeout = null
            }
            previous = now
            result = func.apply(context, args)
            if (!timeout) context = args = null
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining)
        }
        return result
    }
}


export const on = function (eventName, elementSelector, handler, parent = document) {
    parent.addEventListener(eventName, function (e) {
        // loop parent nodes from the target to the delegation node
        for (var target = e.target; target && target != this; target = target.parentNode) {
            if (target.matches(elementSelector)) {
                handler.call(target, e);
                break;
            }
        }
    }, false);
  }

  export const getCookie = function (cookieName) {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
      let [key,value] = el.split('=');
      cookie[key.trim()] = value;
    })
    return cookie[cookieName];
}

export const isCountryInMarket = function (countryIsoCode = '') {
    let userSelectedCountry = getCookie('COUNTRY_SELECTED');

    if(countryIsoCode)
    if (window.Shopify && window.dAgency.marketsConfiguration.marketsByCountry && window.dAgency.marketsConfiguration.marketsByCountry[userSelectedCountry]) {
        const userGeolocatedCountry = Shopify.country;
        const userGeolocatedMarket = window.dAgency.marketsConfiguration.marketsByCountry[userGeolocatedCountry];
        const userMarket = window.dAgency.marketsConfiguration.marketsByCountry[userSelectedCountry];

        return userGeolocatedMarket === userMarket;
    }
}
